import * as Library from '../../../../lib/core/library/index';

export class Price {
  public baseMsrp: number;
  public totalMsrp: number;
  public optTotalMsrp: number;
  public dph: number;
  public fees: number[];

  /*
   * Constructor()
   */
  constructor();
  constructor(options: object);
  constructor(options?: any) {
    this.baseMsrp = Library.init(options, 'baseMsrp', 0);
    this.baseMsrp = Library.init(options, 'baseMsrp', 0);
    this.optTotalMsrp = Library.init(options, 'optTotalMsrp', 0);
    this.dph = Library.init(options, 'dph', 0);
    this.fees = Library.init(options, 'fees', []);
  }
}
